import { render } from "./DashboardNavbar.vue?vue&type=template&id=3b2c09d9"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js"

import "./DashboardNavbar.vue?vue&type=style&index=0&id=3b2c09d9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/layout/DashboardNavbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b2c09d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b2c09d9', __exports__)) {
    api.reload('3b2c09d9', __exports__)
  }
  
  module.hot.accept("./DashboardNavbar.vue?vue&type=template&id=3b2c09d9", () => {
    api.rerender('3b2c09d9', render)
  })

}


export default __exports__